module.exports = __webpack_public_path__ + "img/icon_window_upload@3x.3685a583.png";